export function hasSupabaseEnv(): boolean {
  return Boolean(
    process.env.NEXT_PUBLIC_SUPABASE_URL &&
      (process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY),
  );
}

export function isProductionRuntime(): boolean {
  return process.env.NODE_ENV === "production" || process.env.VERCEL === "1";
}

export function isDemoMode(): boolean {
  // Demo mode only in local/non-production runtimes.
  return !hasSupabaseEnv() && !isProductionRuntime();
}

export function isSupabaseMisconfigured(): boolean {
  return !hasSupabaseEnv() && isProductionRuntime();
}

export function getSupabaseMissingErrorMessage(): string {
  return "Supabase ayarlari eksik. Production icin NEXT_PUBLIC_SUPABASE_URL ve NEXT_PUBLIC_SUPABASE_ANON_KEY (veya NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY) zorunludur.";
}

export function hasIyzicoEnv(): boolean {
  return Boolean(process.env.IYZI_API_KEY && process.env.IYZI_SECRET_KEY && process.env.IYZI_BASE_URL);
}

